import { cloneDeep } from 'lodash'
import * as R from 'ramda'
import i18n from 'i18next'

const getUserRoles = () => ({
    100: i18n.t('userRole_100'),
    110: i18n.t('userRole_110'),
    120: i18n.t('userRole_120'),
    130: i18n.t('userRole_130'),
    140: i18n.t('userRole_140'),
    150: i18n.t('userRole_150'),
    170: i18n.t('userRole_170'),
})

const capitalizeFirstLetter = (str) => {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

const unescapeHtmlTags = (input) => {
    // console.log(input)
    // input = input.replace(/&amp;iquest&#x3b;/g, "&iquest;")
    // input = input.replace(/&amp;oacute&#x3b;/g, "&oacute;")
    // input = input.replace(/&amp;iacute&#x3b;/g, "&iacute;")
    // input = input.replace(/&amp;eacute&#x3b;/g, "&eacute;")
    // input = input.replace(/&amp;nbsp&#x3b;/g, " ")
    // input = input.replace(/&amp;rsquo;/g, "'")
    if (!input) {
        return input
    }
    input = String(input).replace(/&amp;&#x23;39&#x3b;/g, "'")
    input = input.replace(/&amp;&#x23;39;/g, "'")
    input = input.replace(/&amp;/g, '&')
    input = input.replace(/&nbsp;/g, ' ')
    input = input.replace(/&gt;/g, '>')
    input = input.replace(/&lt;/g, '<')
    input = input.replace(/&gt;/g, '>')
    input = input.replace(/&lt;/g, '<')
    input = input.replace(/&#x2f;/g, '/')
    input = input.replace(/&#x3d;/g, '=')
    input = input.replace(/&quot;/g, '"')
    input = input.replace(/&#x3a;/g, ':')
    input = input.replace(/&#x3b;/g, ';')
    input = input.replace(/&#xa;/g, '')// line feed
    input = input.replace(/&#x9;/g, '')// carriage retrn
    input = input.replace(/&#x40;/g, '@')
    input = input.replace(/&#x21;/g, '!')
    input = input.replace(/&#163;/g, '£')
    input = input.replace(/&#x3f;/g, '?')
    input = input.replace(/&#39;/g, "'")
    input = input.replace(/&#x27;/g, "'")
    input = input.replace(/&#x28;/g, '(')
    input = input.replace(/&#x29;/g, ')')
    // console.log(input)
    return input
}

const sortBy = (arr, key, direction = 1) => (
    arr.sort((a, b) => {
        let value = 0
        if (a[key] < b[key]) {
            value = -1
        } else if (a[key] > b[key]) {
            value = 1
        }
        return value * direction
    })
)

const groupBy = (arr, key) => (
    arr.reduce((a, b) => {
        if (!Object.hasOwnProperty.call(a, b[key])) {
            a[b[key]] = []
        }
        a[b[key]].push(b)
        return a
    }, {})
)

const sort = (arr, direction = 1) => (
    arr.sort((a, b) => {
        let order = 0
        if (a > b) {
            order = 1
        } else if (a < b) {
            order = -1
        }
        return order * direction
    })
)

const sortedIndexArray = (values) => (
    Array
        .from(Array(values.length).keys())
        .sort((a, b) => {
            let direction
            if (values[a] < values[b]) {
                direction = -1
            } else if (values[a] > values[b]) {
                direction = 1
            } else {
                direction = 0
            }
            return direction
        })
)

const getSortDirection = (sameSortBy, oldDirection) => {
    let direction
    if (!sameSortBy || !oldDirection) {
        direction = 'ASC'
    } else if (oldDirection === 'ASC') {
        direction = 'DESC'
    } else {
        direction = undefined
    }

    return direction
}

const reorderPagePageBlockIndex = (store, pageId, source, destination) => {
    const { survey } = store
    const { pages } = survey

    const pageBlocks = survey.getPageBlocks().slice()
    const currentPage = pages.find((p) => p.id === pageId)
    let prevPages = []
    let oldIndex
    if (destination.droppableId.includes('pageblock')) {
        const destPageBlock = survey.pageBlocks.find((pb) => pb.id === destination.droppableId.split('_')[1])
        const destPageBlockIndex = pageBlocks.findIndex((pb) => pb.id === destPageBlock.id)
        prevPages = pageBlocks.slice(0, destPageBlockIndex).flatMap((pb) => pb.pages.slice())
        const currentPageIndex = prevPages.indexOf(currentPage.id)
        if (currentPageIndex > -1) {
            prevPages.splice(currentPageIndex, 1)
        }
        oldIndex = pages.findIndex((p) => p.id === currentPage.id)

        return { newIndex: prevPages.length + destination.index, oldIndex }
    }

    prevPages = pageBlocks.flatMap((pb) => pb.pages.slice())
    const currentPageIndex = prevPages.indexOf(currentPage.id)
    if (currentPageIndex > -1) {
        prevPages.splice(currentPageIndex, 1)
    }
    oldIndex = pages.findIndex((p) => p.id === currentPage.id)

    return { newIndex: prevPages.length + destination.index, oldIndex }
}

const getUserLink = (publicId, userId, useLatestUI) => {
    const { protocol } = window.location
    let link = window.location.hostname.split('.')
    if (window.location.hostname === 'dev.admin.staging.explori.com') {
        link = 'surveys.staging.explori.com'.split('.')
    } else if (link.includes('staging') && link[0] !== 'admin') {
        link.splice(0, 2, 'surveys')
    } else if (link[0].match(/tasks/)) {
        link = 'surveys.explori.com'.split('.')
    } else {
        link[0] = 'surveys'
    }
    return `${protocol}//${link.join('.')}/?surveyUuid=${publicId}&surveyUserUUID=${userId}${(useLatestUI ? '&version=v2' : '')}`
}

const setQueryParam = (location, history, paramName, paramValue) => {
    const queryParams = new URLSearchParams(location.search)
    queryParams.set(paramName, paramValue)
    history.push({ search: queryParams.toString() })
}

const getQueryParam = (location, paramName) => {
    const queryParams = new URLSearchParams(location.search)
    const paramValue = queryParams.get(paramName)
    // check for number
    if (/^\d+$/.test(paramValue)) return parseInt(paramValue, 10)
    // check for string
    if (R.is(String, paramValue)) return paramValue
    return -1
}

const removeQueryParam = (location, history, paramName) => {
    const queryParams = new URLSearchParams(location.search)
    queryParams.delete(paramName)
    history.push({ search: queryParams.toString() })
}

const sortAsc = (values) => (
    R.sortWith([
        R.ascend(
            R.compose(
                R.toLower,
                R.prop('label'),
            ),
        ),
    ], values)
)

const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
}

const mapToJSON = (map) => {
    const json = {}
    map.forEach((value, key) => {
        json[key] = typeof value === 'string'
            ? value
            : value.toJSON()
    })
    return json
}

const questionTypeIsInheritable = (questionType) => (
    ['RD', 'CH', 'CO', 'SB'].includes(questionType)
)

const questionTypeCanInherit = (questionType) => (
    !['ST', 'TX', 'TA', 'I'].includes(questionType)
)

const download = (href, fileName) => {
    const downloadLink = document.createElement('a')
    downloadLink.href = href
    downloadLink.download = fileName
    downloadLink.click()
}

const getProductMap = async (http, clientId, getAllData = false, token) => {
    const url = getAllData
        ? '/productmap'
        : `/productmap/${clientId}`
    const productMaps = await http.get(url, token)
    return productMaps.reduce((obj, m) => {
        const newObj = { ...obj }
        const respondentPath = [m.industrycode, 'children', m.producttypecode, 'children', m.surveytypecode, 'children', m.respondenttypecode]
        const industryLens = R.lensPath(respondentPath.slice(0, 1))
        const productTypeLens = R.lensPath(respondentPath.slice(0, 3))
        const surveyTypeLens = R.lensPath(respondentPath.slice(0, 5))
        const respondentTypeLens = R.lensPath(respondentPath)

        return R.pipe(
            (obj) => R.set(industryLens, R.or(R.view(industryLens, obj), { value: m.industrycode, label: m.industryname, children: {} }), obj),
            (obj) => R.set(productTypeLens, R.or(R.view(productTypeLens, obj), {
                value: m.producttypecode, label: m.producttypename, productTypeNameOnly: m.productTypeNameOnly, children: {},
            }), obj),
            (obj) => R.set(surveyTypeLens, R.or(R.view(surveyTypeLens, obj), { value: m.surveytypecode, label: m.surveytypename, children: {} }), obj),
            (obj) => R.set(respondentTypeLens, R.or(R.view(respondentTypeLens, obj), { value: m.respondenttypecode, label: m.respondenttypename }), obj),
        )(newObj)
    }, {})
}

const getChildrenKeys = (obj) => R.keys(obj.children)
const getChildrenValues = (obj) => R.values(obj.children)

const getIndustries = (productMap, full = false) => (full ? R.values(productMap) : R.keys(productMap))

const getProductTypes = (productMap, full = false) => (
    R.chain(full ? getChildrenValues : getChildrenKeys, R.values(productMap))
)

const getSurveyTypes = (productMap, full = false) => (
    R.chain(R.chain(full ? getChildrenValues : getChildrenKeys), R.map(getChildrenValues, R.values(productMap)))
)

const getRespondentTypes = (productMap, full = false) => (
    R.chain(
        full ? getChildrenValues : getChildrenKeys,
        R.chain(
            R.chain(getChildrenValues),
            R.map(getChildrenValues, R.values(productMap)),
        ),
    )
)

const productMapTreeviewOptions = (productMap) => {
    let numOptions = 0
    const depths = {
        0: 'industry',
        1: 'product',
        2: 'survey',
        3: 'respondent',
    }
    const formatTreeviewChildren = (children, depth, parent) => (
        Object.values(children).reduce((newChildren, child) => {
            const newChild = cloneDeep(child)
            if (newChild.children) {
                newChild.children = formatTreeviewChildren(
                    newChild.children, depth + 1,
                    `${parent}_${newChild.value}`,
                )
                newChild.checked = true
            }
            numOptions += 1
            newChild.type = depths[depth]
            newChild.value = `${parent}_${newChild.value}`
            newChildren.push(newChild)
            return newChildren
        }, [])
    )
    const buildTreeviewOptions = () => {
        const treeviewOptions = Object.values(productMap).reduce((options, option) => {
            options.push({
                ...option,
                checked: true,
                type: depths[0],
                children: option.children
                    ? formatTreeviewChildren(option.children, 1, option.value)
                    : undefined,
            })
            numOptions += 1
            return options
        }, [])
        return treeviewOptions
    }
    return { options: buildTreeviewOptions(), numOptions }
}

const getDefaultCheckedAdminTagPairs = (availableTags) => (
    availableTags.reduce((pairs, {
        tagId, isAdminTag, defaultValue, options,
    }) => {
        if (!isAdminTag || !defaultValue) return pairs // only adminTags have defaults
        const optionId = R.path([0, 'value'], options)
        return R.isNil(optionId) ? pairs : pairs.concat([[tagId, optionId]])
    }, [])
)

const getCurrencySymbol = (currency, userLocale = 'en-GB') => {
    const locale = userLocale.replace('_', '-')
    let currencySymbol
    let currencySymbolFull

    try {
        currencySymbolFull = (0).toLocaleString(
            locale,
            {
                style: 'currency',
                currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            },
        ).replace(/\d/g, '').trim()
        currencySymbol = currencySymbolFull.slice(-1)
    } catch (e) {
        currencySymbol = currency
    }
    if (currencySymbol === '$' && currency !== 'USD') {
        return currencySymbolFull
    }
    return currencySymbol
}

export {
    getUserRoles,
    unescapeHtmlTags,
    sortBy,
    sort,
    sortedIndexArray,
    getSortDirection,
    reorderPagePageBlockIndex,
    getUserLink,
    setQueryParam,
    getQueryParam,
    removeQueryParam,
    sortAsc,
    mapToJSON,
    stripHtml,
    groupBy,
    download,
    questionTypeIsInheritable,
    questionTypeCanInherit,
    getProductMap,
    getIndustries,
    getProductTypes,
    getSurveyTypes,
    getRespondentTypes,
    productMapTreeviewOptions,
    getCurrencySymbol,
    capitalizeFirstLetter,
    getDefaultCheckedAdminTagPairs,
}
